//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[],[[[],"EnableTransientGraphicsSuppression",{},0,0],[[],"GetGraphicsProcessingState",{R_:{graphicsProcessingState:''}},0,1],[["graphicsProcessingState"],"SetGraphicsProcessingState",{},1,1],[["components","includeChildren"],"RegenerateGraphicsForComponents",{},2,1],[["components","includeChildren"],"GenerateComponentGraphics",{},2,0],[[],"GenerateSketchRelationSymbolTable",{},0,0]],[]];
SPLM.AtlasGraphics = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AtlasGraphics";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AtlasGraphics.GraphicsProcessingState = Object.freeze({
    "UnSuppressed" : "UnSuppressed", "Suppressed" : "Suppressed"});

export default SPLM;